export const GIS_ZHKH_KEY = 'gis_zhkkh';
export const GIS_ZHKH_PRICE_LABEL = '50 ₽/мес';
export const GIS_PENDING_PAYMENT_KEY = 'gis_zhkkh_pending_payment';
export const GIS_ZHKH_SERIAL_HINT =
  'Серийные номера счётчиков должны совпадать с данными в ГИС ЖКХ. Иначе передача показаний будет недоступна.';

export const GIS_STATUS_LABELS = {
  waiting_payment: 'Ожидает оплаты',
  active: 'Активна',
};

export const GIS_STATUS_CLASS_NAME = {
  waiting_payment: 'bg-amber-50 text-amber-700',
  active: 'bg-green-50 text-green-700',
};

export const isGisZhkkh = (key) => key === GIS_ZHKH_KEY;
